import { render } from "./prepaid-site.vue?vue&type=template&id=196942c7&scoped=true"
import script from "./prepaid-site.vue?vue&type=script&lang=js"
export * from "./prepaid-site.vue?vue&type=script&lang=js"

import "./prepaid-site.vue?vue&type=style&index=0&id=196942c7&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196942c7"]])

export default __exports__